import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=d82ca686&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=d82ca686&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82ca686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d82ca686')) {
      api.createRecord('d82ca686', component.options)
    } else {
      api.reload('d82ca686', component.options)
    }
    module.hot.accept("./UserCard.vue?vue&type=template&id=d82ca686&scoped=true", function () {
      api.rerender('d82ca686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/user/components/UserCard.vue"
export default component.exports